import React from 'react';
import { IconAutomatic, IconErrorSmall } from '../../../../../assets/icons';
import './index.scss';

type PropsInferface = {
  isValid: boolean;
};

export const TriggerIcon: React.FC<PropsInferface> = ({ isValid }) => (
  <div className="trigger-icon">
    <div className="trigger-icon__icon">
      <IconAutomatic className="icon-automatic--accent" />
      {!isValid && <IconErrorSmall size={18} />}
    </div>
  </div>
);
